import { render, staticRenderFns } from "./budget-details.vue?vue&type=template&id=012b9a84&scoped=true&"
import script from "./budget-details.vue?vue&type=script&lang=js&"
export * from "./budget-details.vue?vue&type=script&lang=js&"
import style0 from "./budget-details.vue?vue&type=style&index=0&id=012b9a84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b9a84",
  null
  
)

export default component.exports